<template lang="pug">
  v-container.pa-0(fluid)
    v-card
      v-card-title {{ $t('bankTransactionPage.newTransaction') }}
      v-row.justify-center.ma-0
        v-col.py-0
          v-alert.ma-0(else type="warning") {{ $t('bankTransactionPage.unprocessedTransactionMessage') }}
      v-card-text.title {{getTitle}}
        v-container.pa-0
          v-tabs
            v-tab {{ $t('bankTransactionPage.propertiesTabLabel') }}
            v-tab {{ $t('bankTransactionPage.amountToWalletTabLabel') }}

            v-tab-item
              BankTransactionPropertiesTab( v-if="newTransaction" :transactionDetail="newTransaction" )
            v-tab-item
              BankTransactionAmountToWalletTab( v-if="newTransaction.invoices" :transactionDetail="newTransaction")


      v-divider
      v-card-actions
        v-btn(color="orange" text @click="onResolve")  {{ $t('bankTransactionPage.resolveTransaction') }}
        v-spacer
        v-btn(color="primary"  @click="onSubmitButtonClick")  {{ $t('bankTransactionPage.finishButtonLabel') }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop,} from 'vue-property-decorator'
import ResolveTransactionDialog from "@/components/user/ResolveTransactionDialog.vue";
import BankTransaction from "@/model/BankTransaction/BankTransaction";
import TransactionInvoice from "@/model/BankTransaction/TransactionInvoice";
import BankTransactionPropertiesTab from "@/components/user/BankTransactionPropertiesTab.vue";
import BankTransactionAmountToWalletTab from "@/components/user/BankTransactionAmountToWalletTab.vue";

@Component({
  components: {
    ResolveTransactionDialog,
    BankTransactionPropertiesTab,
    BankTransactionAmountToWalletTab

  },
})
export default class ControlFailDialog extends Vue {
  @Prop({ type: Object, required: false}) readonly newTransaction!: BankTransaction

  get getTitle (): string {
    if(this.newTransaction.boarder && this.newTransaction.boarder.person && this.newTransaction.boarder.person.firstName && this.newTransaction.boarder.person.familyName) {
      return `${this.newTransaction.boarder.person.firstName} ${this.newTransaction.boarder.person.familyName}`
    } else {
      return ''
    }
  }

  getCredit (item: TransactionInvoice) {
    if(item){
      return item.invoice.amountFromWallet / 100
    }
  }

  getInvoices (item: TransactionInvoice) {
    if(item){
      return item.amountPayed / 100
    } else {
      return 0
    }
  }


  onSubmitButtonClick () {
    this.$emit('complete')
  }

  onResolve () {
    this.$emit('openResolveDialog')
  }

  mounted() {
  }
}

</script>

<style lang="stylus" scoped>

.style
  color: green

</style>
